import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=4aa751c6&"
import script from "./ModuleEdit.vue?vue&type=script&lang=ts&"
export * from "./ModuleEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa751c6')) {
      api.createRecord('4aa751c6', component.options)
    } else {
      api.reload('4aa751c6', component.options)
    }
    module.hot.accept("./ModuleEdit.vue?vue&type=template&id=4aa751c6&", function () {
      api.rerender('4aa751c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModuleEdit.vue"
export default component.exports